var rNonQuerystring = /\+/g

var deparam = exports.deparam = function (string) {
  var params = {}
    , paramsArray = string.replace(rNonQuerystring, ' ').split('&')

  for (var i = 0, l = paramsArray.length; i < l; i++) {
    var paramString = paramsArray[i]
      , pair = paramString.split('=')
      , paramName = decodeURIComponent([pair[0]])
      , paramValue = pair.length>2?decodeURIComponent([pair.slice(1).join('=')]):decodeURIComponent([pair[1]])
    if(/^.*\[\]$/.test(paramName)){
      paramName=paramName.substr(0,paramName.length-2);
      params[paramName]=params[paramName]||[];
      params[paramName].push(paramValue);
      continue;
    }
    paramName&&(params[paramName] = paramValue)
  }

  return params
}

// copy from
// https://github.com/jfromaniello/url-join/blob/master/lib/url-join.js
// version: b02169596877a1e6cd518f1b0d711f38c721fb02
function normalize(str) {
  return str
    .replace(/[\/]+/g, '/')
    .replace(/\/\?/g, '?')
    .replace(/\/\#/g, '#')
    .replace(/\:\//g, '://')
}

var join = exports.join = function() {
  var joined = [].slice.call(arguments, 0).join('/')
  return normalize(joined)
}


function getUrlCompontents(url) {
  var hash = ''
    , search = ''
    , rest = url
    , hashIndex = rest.indexOf('#')
    , markIndex = rest.indexOf('?')

  if (hashIndex !== -1) {
    hash = rest.substr(hashIndex)
    rest = rest.slice(0, hashIndex)
  }

  if (markIndex !== -1) {
    search = rest.substr(markIndex)
    rest = rest.slice(0, markIndex)
  }

  return { rest: rest, search: search, hash: hash }
}

function removeSearch(url) {
  var compontents = getUrlCompontents(url)
  return compontents.rest + (compontents.hash || '')
}

exports.resetParams = function(url, params) {
  return exports.addParam(removeSearch(url), params)
}

exports.addParam = function(url, params) {
  var paramString = ''

  for (var key in params) {
    if (!params.hasOwnProperty(key)) { continue }

    var value = params[key]
    if (value === '' || typeof value === 'undefined') { continue }

    if (paramString) { paramString += '&' }
    paramString += encodeURIComponent(key)
      + '=' + encodeURIComponent(value)
  }

  if (!paramString) { return url }

  var compontents = getUrlCompontents(url);

  var hash = compontents.hash
    , search = compontents.search
    , rest = compontents.rest

  return (rest
    + (search ? (search + '&' + paramString) : ('?' + paramString))
    + (hash ? hash : ''))
}

var hasSameOrigin = exports.hasSameOrigin = function(url, originUrl) {
  if (url[0] === '/') { return true }
  var rOrigin = new RegExp('^' + originUrl)
  return rOrigin.test(url)
}

exports.getRelativeUrl = function(url, originUrl) {
  if (url[0] === '/' || !hasSameOrigin(url, originUrl)) { return url }
  return join('/', url.substr(originUrl.length))
}

exports.getURLParameter = function(name, search) {
  search = search || location.search
  var param = search.split(name + '=')[1];
  return param ? decodeURIComponent(param.split('&')[0]) : null
}

var rQuestionMark = /^\?/
exports.getURLParameters = function(search) {
  search = search || location.search
  search = search.replace(rQuestionMark, '');
  return deparam(search)
}

// Copy From Backbone.js#Backbone.Route
//   Gets the true hash value. Cannot use location.hash directly due to bug
//   in Firefox where location.hash will always be decoded.
exports.getHash = function() {
  var match = window.location.href.match(/#(.*)$/)
  return match ? match[1] : ''
}
